import { Button, Text } from '@heathmont/moon-components';
import styled from 'styled-components';
import Translate from '~/client/shared/i18n/Translate';
import FlexStack from '~/client/shared/styles/FlexStack';

type Props = {
  handleClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  translateId: string;
};

const UnderlinedText = styled(Text)`
  text-decoration: underline;
`;
const HavingTroubles: FC<Props> = ({ handleClick, translateId }) => (
  <FlexStack gridGap="4px" inline justifyContent="center" alignItems="center">
    <Text size={14} color="trunks.100">
      <Translate id="profile.having_troubles" />
    </Text>
    <Button onClick={handleClick} size="small">
      <UnderlinedText size={14}>
        <Translate id={translateId} />
      </UnderlinedText>
    </Button>
  </FlexStack>
);

export default HavingTroubles;
